function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Window"
}, /*#__PURE__*/React.createElement("title", null, "VF_window_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M0 14.2v255.1h283.5V14.2H0zm255.1 78h-99.3V42.5h99.3v49.7zM127.5 42.5v49.6H28.4V42.5h99.1zm-99.2 78h99.1v120.4h-99l-.1-120.4zm127.5 120.4V120.5h99.3v120.4h-99.3z"
}))));